import { render, staticRenderFns } from "./ConfirmUsers.vue?vue&type=template&id=4863b6fa"
import script from "./ConfirmUsers.vue?vue&type=script&lang=js"
export * from "./ConfirmUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports